var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGynecology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 31",
    style: {
      enableBackground: "new 0 0 31 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.5,28.75c0.63-0.8,0.25-3.23,0.29-4.48 c0.06-1.59,0.68-2.83,1.81-3.4c1.13-0.56,1.19-2.65,0.45-3.22c-0.73-0.56-0.73-2.03,0.79-3.05c1.53-1.02,1.48-3.28,1.48-3.28V7.08 c-1.6-1.4-4.2-1.52-5.04-1.52c-0.18-0.01-0.28,0-0.28,0c-0.84,0-3.44,0.12-5.04,1.52v4.24c0,0-0.06,2.26,1.48,3.28 c1.52,1.02,1.52,2.49,0.79,3.05c-0.74,0.57-0.68,2.66,0.45,3.22c1.13,0.57,1.75,1.81,1.81,3.4c0.04,1.25-0.34,3.68,0.29,4.48"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.27,29.95c1.54-0.15,1.54-1.67,1.54-1.67 s-0.17-2.83,0-4.41c0.17-1.59,0.68-1.93,1.92-2.83c1.24-0.9,0.96-3.39,0.17-3.95c-0.79-0.57-0.28-0.85,1.36-2.61 c1.64-1.75,1.07-7.4,1.07-7.4s0.09-0.65,2.23-2c2.15-1.36,3.33,0.56,3.33,0.56c0.32,0.7,0.4,1.48,0.05,2.17 c-0.11,0.23-0.26,0.45-0.45,0.63c-0.2,0.2-0.43,0.37-0.61,0.59c-0.25,0.28-0.45,0.6-0.64,0.92c-0.33,0.55-0.6,1.14-0.8,1.76 c-0.26,0.82-0.41,1.69-0.4,2.56c0,0.11,0.01,0.22,0.02,0.33c0.13-0.09,0.27-0.14,0.41-0.14c0.19,0,0.36,0.08,0.51,0.23 c0-0.05,0-0.07,0-0.07c-0.29-3.55,2.2-5.64,2.2-5.64s1.56-1.8,0.74-3.28c0,0-0.46-1.64-2.66-1.92c-1.82-0.24-4.46,2.59-4.46,2.59 c-1.84-1.64-4.64-1.96-5.52-2.02h-0.16c-0.03,0-0.07,0-0.12,0.01c-0.89,0.05-3.68,0.37-5.52,2.01c0,0-2.64-2.83-4.46-2.59 C2.82,4.06,2.36,5.7,2.36,5.7C1.54,7.18,3.1,8.98,3.1,8.98s2.49,2.09,2.2,5.64c0,0,0,0.02,0,0.07c0.15-0.15,0.32-0.23,0.51-0.23 c0.14,0,0.28,0.05,0.41,0.13c0.01-0.1,0.01-0.21,0.01-0.32c0.02-0.87-0.13-1.74-0.39-2.56c-0.2-0.62-0.47-1.21-0.8-1.76 C4.85,9.63,4.64,9.31,4.4,9.03C4.22,8.81,3.99,8.64,3.79,8.44C3.6,8.26,3.45,8.04,3.34,7.81C2.99,7.12,3.06,6.34,3.38,5.64 c0,0,1.19-1.92,3.33-0.56c2.15,1.35,2.23,2,2.23,2s-0.56,5.65,1.08,7.4c1.64,1.76,2.15,2.04,1.36,2.61 c-0.79,0.56-1.07,3.05,0.17,3.95c1.24,0.9,1.75,1.24,1.92,2.83c0.17,1.58,0,4.41,0,4.41s0,1.52,1.53,1.67H15.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC"
    },
    d: "M6.22,14.59v0.01c0,0.05-0.01,0.09-0.01,0.14c0,0-0.06,0.73-0.51,0.62c-0.36-0.09-0.4-0.52-0.4-0.67 c0.15-0.15,0.32-0.23,0.51-0.23C5.95,14.46,6.09,14.51,6.22,14.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.5,28.75c0.63-0.8,0.25-3.23,0.29-4.48 c0.06-1.59,0.68-2.83,1.81-3.4c1.13-0.56,1.19-2.65,0.45-3.22c-0.73-0.56-0.73-2.03,0.79-3.05c1.53-1.02,1.48-3.28,1.48-3.28V7.08 c-1.6-1.4-4.2-1.52-5.04-1.52c-0.18-0.01-0.28,0-0.28,0c-0.84,0-3.44,0.12-5.04,1.52v4.24c0,0-0.06,2.26,1.48,3.28 c1.52,1.02,1.52,2.49,0.79,3.05c-0.74,0.57-0.68,2.66,0.45,3.22c1.13,0.57,1.75,1.81,1.81,3.4c0.04,1.25-0.34,3.68,0.29,4.48 C14.78,28.75,15.021,29.141,15.5,28.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.49,21.34c2.7-1.72,1.72-2.59,1.72-2.59 c-1.75-0.96-0.79-4.42,0.57-4.92c1.35-0.51,1.35-2.94,1.35-2.94v-2.6c-1.35-1.13-3.19-1.24-3.19-1.24h-1.61 c0,0-1.83,0.11-3.18,1.24v2.6c0,0,0,2.43,1.35,2.94c1.36,0.5,2.32,3.96,0.57,4.92c0,0-0.98,0.87,1.72,2.59 C14.79,21.34,15.157,21.561,15.49,21.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M7,16.75c0,1.26-0.53,2.29-1.19,2.29 c-0.65,0-1.19-1.03-1.19-2.29c0-0.91,0.28-1.7,0.68-2.06c0.15-0.15,0.32-0.23,0.51-0.23c0.14,0,0.28,0.05,0.41,0.13v0.01 C6.67,14.91,7,15.75,7,16.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC"
    },
    d: "M24.98,14.69c0,0.15-0.04,0.58-0.4,0.67c-0.45,0.11-0.51-0.62-0.51-0.62c0-0.05-0.01-0.09-0.01-0.14 c0.13-0.09,0.27-0.14,0.41-0.14C24.66,14.46,24.83,14.54,24.98,14.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M25.65,16.75c0,1.26-0.53,2.29-1.18,2.29 c-0.66,0-1.19-1.03-1.19-2.29c0-1,0.33-1.84,0.78-2.15c0.13-0.09,0.27-0.14,0.41-0.14c0.19,0,0.36,0.08,0.51,0.23 C25.38,15.05,25.65,15.84,25.65,16.75z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGynecology);
export default __webpack_public_path__ + "static/media/gynecology.1cf29ce0dd5a6a0643474831e4a8c49a.svg";
export { ForwardRef as ReactComponent };